import { useRef, useState } from "react";
import { Camera, ImagePlus, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, apiError, fileUrl } from "@/lib/api";
import { compressImage, MAX_PHOTO } from "@/lib/format";

export default function PhotoInput({ value, onChange, label = "Photo (facultative)", testId = "photo" }) {
  const camRef = useRef(null);
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) return toast.error("Choisissez une image.");
    setBusy(true);
    try {
      const blob = await compressImage(file);
      if (blob.size > MAX_PHOTO) throw new Error("La photo dépasse 5 Mo, même après compression.");
      const form = new FormData();
      form.append("file", blob, "photo.jpg");
      const { data } = await api.post("/upload", form);
      onChange(data.path);
    } catch (err) {
      toast.error(err.response ? apiError(err) : err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <span className="field-label">{label}</span>
      {value ? (
        <div className="relative w-full max-w-[220px]">
          <img src={fileUrl(value)} alt="" className="w-full aspect-[4/3] object-cover rounded-[10px] border border-[#E1E4DD]" data-testid={`${testId}-preview`} />
          <button type="button" onClick={() => onChange(null)} className="absolute top-2 right-2 bg-white rounded-full p-1 shadow" data-testid={`${testId}-remove`} aria-label="Retirer la photo"><X size={14} /></button>
        </div>
      ) : (
        <div className="flex flex-wrap gap-2">
          <button type="button" className="btn-outline btn-sm" onClick={() => camRef.current.click()} disabled={busy} data-testid={`${testId}-camera-btn`}>
            {busy ? <Loader2 size={15} className="animate-spin" /> : <Camera size={15} />} Prendre une photo
          </button>
          <button type="button" className="btn-outline btn-sm" onClick={() => fileRef.current.click()} disabled={busy} data-testid={`${testId}-file-btn`}>
            <ImagePlus size={15} /> Choisir un fichier
          </button>
        </div>
      )}
      <input ref={camRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={handle} data-testid={`${testId}-camera-input`} />
      <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={handle} data-testid={`${testId}-file-input`} />
      <p className="text-xs text-[#5B665F] mt-1.5">5 Mo maximum, compressée automatiquement.</p>
    </div>
  );
}
